import styled from 'styled-components';

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;
